import React from 'react';
import { useState } from 'react';
import { WORKING_HOURS } from '../../helper_functions/helper_functions';
import { randomID } from '../../helper_functions/helper_functions';
import SelectOptions from '../homePage/SelectOptions';

const FinishToEmployer = ({ 
  employees, 
  vehicles, 
  handleCurrentContainer, 
  updateemployeesAndvehicles, 
  handleFinishedOrders,
  assistantPassword,
  percentage
}) => {
  const [errorMassage, setErrorMassage] = useState('');
  const [password, setPassword] = useState('');
  const [container, setContaier] = useState('');
  const [outEmployer, setOutEmployer] = useState('');
  const [outvehicle, setOutvehicle] = useState('');
  const [employerWillTake, setEmployerWillTake] = useState('');
  const [employerToUpdate, setEmployerToUpdate] = useState('');
  const [vehicleToUpdate, setvehicleToUpdate] = useState('');
  const [saveUpdatevehicle, setSaveUpdatevehicle] = useState(false);

  const handleChooseOutEmployer = (e, action) => {
    let outE = '';
    let outM = '';
    let outMID = '';
    switch (action) {
      case 'finish':
        for (let em of employees) {
          if (em.id === e.target.value) {
            outE = em
            outMID = em.vehicle.id
          }
        }
        for (let m of vehicles) {
          if (m.id === outMID) {
            outM = m
          }
        }
         
        setOutEmployer(outE);
        setOutvehicle(outM);
        break;
      case 'update-employer':
        for (let em of employees) {
          if (em.id === e.target.value) {
            outE = em
            outMID = em.vehicle.id
          }
        }
        setEmployerToUpdate(outE);
        break;
      case 'update-vehicle':
        let newvehicles = [...vehicles]
        for (let m of newvehicles) {
          if (m.id === e.target.value) {
            outM = m
          }
        }
        setvehicleToUpdate(outM);
        break;
      default:
    }
  }

  const priceCalculator = (action) => {
    switch (action) {
      case 'total': 
        let total = 0;
        for (let x = 0; x <= outEmployer.finishedOrders.length-1; x++) {
          total += Number(outEmployer.finishedOrders[x].price)
        }
        return total;
      default:
    }
  }
  
  const handleFinish = (e) => {
    e.preventDefault();
    handleFinishedOrders(outEmployer.finishedOrders)
    let data = {
      orders: [...outEmployer.finishedOrders],
      employerMoney: employerWillTake[1],
      systemTotalPrice: Number(priceCalculator('total')),
      employerInputPrice: employerWillTake[0],
      startedAt: [outEmployer.time[0] , outEmployer.time[1]],
      workingHours: WORKING_HOURS(outEmployer.date),
      roundID: randomID(),
      date: outEmployer.date
    }

    let formData = new FormData(e.target);
    let petrol = formData.get('petrol')
    let oil = formData.get('oil')
    let repairs = formData.get('repairs')
    
    let newvehicles = [...vehicles].map((m) => {
      if (m.id === outEmployer.vehicle.id) {
        m.finishedOrdersContainer.push(Object.assign(
          {}, 
          data,
          {
          employer: {id: outEmployer.id, name: outEmployer.name},
          }));
        m.state = 'off';
        m.employer = '';
        m.orders = [];
        m.finishedOrders = [];
        m.expenses = {
          petrol: (petrol ? petrol : 0),
          oil: (oil ? oil : 0),
          repairs: (repairs ? repairs : 0)}
        m.date = '';
      }
      return m
    })
    let newemployees = [...employees].map((e) => {
      if (e.id === outEmployer.id) {
        e.finishedOrdersContainer.push(Object.assign({}, data, {vehicle: outEmployer.vehicle}));
        e.state = 'off';
        e.vehicle = '';
        e.orders = [];
        e.finishedOrders = [];
        e.time = [];
        e.date = '';
      }
      return e
    })

    updateemployeesAndvehicles(newemployees, newvehicles)
    handleCurrentContainer('');
  }
  const checkTotalPrice = (e, action) => {
    let value = e.target.value;
    switch(action.type) {
      case 'finish':
        if (Number(value) < Number(priceCalculator('total'))) {
          setErrorMassage('Total Price Must be >= Orders Price')
        }else {
          setEmployerWillTake([Number(value), ((Number(value) / 100) * Number(percentage)).toFixed(2)])
          setErrorMassage('')
        }
        break;
      case 'update':
        if (Number(value) < Number(action.value)) {
          setErrorMassage('Total Money Must be >= Orders Price')
        }else {
          let newEmployerMoney = {...employerWillTake};
          newEmployerMoney[action.id] = ((Number(value) / 100) * Number(percentage)).toFixed(2)
          
          setEmployerWillTake(newEmployerMoney)
          setErrorMassage('')
        }
        break;
      default:
    }
  }

  const handleUpdateEmployerAndvehicle = (e, action) => {
    e.preventDefault();
    let formData = new FormData(e.target);
    switch (action.type) {
      case 'employer':
        let value = formData.get('totalMoney');
        
        let newEmployerMoney = {...employerWillTake}
        let rounds = `round${action.id}`;

        let outM = ''

        let newEFinishedOrdersContainer = {...employerToUpdate}.finishedOrdersContainer.map((round, i) => {
          if (round.roundID === action.id) {
            round.employerMoney = newEmployerMoney[rounds];
            round.employerInputPrice = value;
            outM = round.vehicle.id
          }
          return round;
        })
 
        let newemployees = [...employees].map((em) => {
          if (em.id === employerToUpdate.id) {
            em.finishedOrdersContainer = [...newEFinishedOrdersContainer]
          }
          return em;
        });
        let newvehicles = [...vehicles].map((m) => {
          if (m.id === outM) {
            m.finishedOrdersContainer = m.finishedOrdersContainer.map((round, i) => {
                if (round.roundID === action.id) {
                  round.employerMoney = newEmployerMoney[rounds];
                  round.employerInputPrice = value;
                }
                return round;
              })

          }
          return m;
        });
        newEmployerMoney[rounds] = '';
        
        setEmployerWillTake(newEmployerMoney)
        updateemployeesAndvehicles(newemployees, newvehicles)
        break;
      case 'vehicle':
        let newM = [...vehicles].map((m) => {
          if (m.id === vehicleToUpdate.id) {
            return vehicleToUpdate;
          }
          return m
        })
        setSaveUpdatevehicle(false)
        updateemployeesAndvehicles('', newM)
        break;
      default:
    }
  }

  const handleUpdatevehicle = (e) => {
    let name =  e.target.name;
    let value =  Number(e.target.value);
    let newvehicle = {...vehicleToUpdate};
    
    newvehicle.expenses[name] = value;
    setvehicleToUpdate(newvehicle)
    setSaveUpdatevehicle(true);
  }

  return (
    <div>
      <h3>End of working hours</h3>
      {(password) !== (assistantPassword) && 
      <input 
        className='choose-em'
        type='password'
        placeholder='demo password 1 '
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />}
      {password === assistantPassword && !container &&
      <div className='buttons-con'>
        <button
          onClick={() => setContaier('finish')}  
        >Finish</button>
        <br />
        <br />
        <hr />
        <br />
        <button 
          onClick={() => setContaier('update-employer')}  
        >Update Employer</button>
        <button 
          onClick={() => setContaier('update-vehicle')}  
        >Update vehicle</button>
      </div>
      }
      {(password) === (assistantPassword) && container === 'finish' && 
      <>
      <h4>( Finish page )</h4>
      <form >
        <div className='form-layer'>
          <label htmlFor='employer'>choose employee</label>
          <select className='choose-em' id='employer' onChange={(e) => handleChooseOutEmployer(e, 'finish')}>
            <SelectOptions 
              options={employees} 
              state='on'
            />
          </select>
        </div>
      </form>
      {outEmployer && (outEmployer.orders.length > 0 || outEmployer.finishedOrders.length <= 0) && <p className='error-massage'>The employer still has incomplete orders</p>}
      {outEmployer && !outEmployer.orders.length && outEmployer.finishedOrders.length > 0 && 
      <>
      <div className='form-layer price-value'>
        <p>He started at</p>
        <p> {outEmployer.time[0]} : {outEmployer.time[1]}</p>
      </div>
      <div className='form-layer price-value'>
        <p>his number of working hours</p>
        <p>{WORKING_HOURS(outEmployer.date)}</p>
        {/* <p>{workingHours(outEmployer.date)[0] + ' : '  + workingHours(outEmployer.date)[1]}</p> */}
      </div>
      <div className='form-layer price-value'>
        <p>His Finished Orders </p>
        <p>{outEmployer.finishedOrders.length}</p>
      </div>
      <div className='form-layer price-value'>
        <p>Percentage for salary</p>
        <p>% {percentage}</p>
      </div>
      <form className='employer-data' onSubmit={handleFinish}>
        <br />
        <hr />
        <br />
        {errorMassage && <p className='error-massage'>{errorMassage}</p>}
        <p className='form-title'>Enter the employer data</p>
        <div className='form-layer price-value'>
          <p>total money</p>
          <input className='choose-em' type='number' name='totalMoney' defaultValue="" onChange={(e) => checkTotalPrice(e, {type: 'finish'})} placeholder='$$$' min={priceCalculator('total')} required />
        </div>
        <br />
        <hr />
        <br />
        <p className='form-title'>Enter the <span style={{color: '#000'}}>( {outvehicle.name} )</span> Expenses data</p>
          
        <div className='form-layer price-value'>
          <p>Petrol</p>
          <input className='choose-em' type='number' defaultValue={outvehicle.expenses.petrol} name='petrol' min='0' placeholder='$$$' />
        </div>
        <div className='form-layer price-value'>
          <p>Oil</p>
          <input className='choose-em' type='number' defaultValue={outvehicle.expenses.oil} name='oil' min='0' placeholder='$$$' />
        </div>
        <div className='form-layer price-value'>
          <p>Repairs</p>
          <input className='choose-em' type='number' defaultValue={outvehicle.expenses.repairs} name='repairs' min='0' placeholder='$$$' />
        </div>
        {!errorMassage && employerWillTake && 
        <div className='form-layer price-value'>
          <p>Employer will take </p>
          <p>$ {employerWillTake[1]}</p>
        </div>
        }
        {!errorMassage && employerWillTake && <button>Finish</button>}
      </form>
        </>}
      </>}

      {(password) === (assistantPassword) && container === 'update-employer' && 
      <>
        <h4>( Update employees) <br /> (Rounds Page )</h4>
        <form>
          <div className='form-layer'>
            <label htmlFor='employer'>choose employee</label>
            <select className='choose-em' id='employer' onChange={(e) => handleChooseOutEmployer(e, 'update-employer')}>
              <SelectOptions 
                options={employees} 
                state='end'
              />
            </select>
          </div>
        </form>

        {employerToUpdate && employerToUpdate.finishedOrdersContainer.length === 0 && <p className='error-massage'>The employer still has incomplete rounds</p>}
        {employerToUpdate && employerToUpdate.finishedOrdersContainer.length > 0 && 
          employerToUpdate.finishedOrdersContainer.map((round, i) => (
            <div key={i}>
            <p className='form-title'>round number " {i + 1} "</p>
            <div className='form-layer price-value'>
              <p>started at</p>
              <p> {round.startedAt[0]} : {round.startedAt[1]}</p>
            </div>
            <div className='form-layer price-value'>
              <p>number of working hours</p>
              <p>{round.workingHours[0]} : {round.workingHours[1]}</p>
            </div>
            <div className='form-layer price-value'>
              <p>his vehicle</p>
              <p>{round.vehicle.name}</p>
            </div>
            <div className='form-layer price-value'>
              <p>round money </p>
              <p>$ {round.employerInputPrice}</p>
            </div>
            <div className='form-layer price-value'>
              <p>orders numbers</p>
              <p>{round.orders.length}</p>
            </div>
            <div className='form-layer price-value'>
              <p>he take </p>
              <p>$ {round.employerMoney}</p>
            </div>
            {errorMassage && <p className='error-massage'>{errorMassage}</p>}
            <form  className='employer-data' onSubmit={(e) => handleUpdateEmployerAndvehicle(e, {type: 'employer', id: round.roundID})}>
              <div className='form-layer price-value'>
                <p>total money</p>
                <input className='choose-em' type='number' name='totalMoney' onChange={(e) => checkTotalPrice(e, {type: 'update', value: round.systemTotalPrice, id: `round${round.roundID}`})} placeholder='$$$' min={round.systemTotalPrice} required />
              </div>
              {!errorMassage && employerWillTake[`round${round.roundID}`] && 
              <>
              <div className='form-layer price-value'>
                <p>Employer will take </p>
                <p>$ {employerWillTake[`round${round.roundID}`]}</p>
              </div>
              <button>Save</button>
              </>
              }
            </form>
            <br />
            </div>
          ))
        }
      </>}
      {(password) === (assistantPassword) && container === 'update-vehicle' && 
      <>
        <h4>( Update vehicles)</h4>

        <form>
          <div className='form-layer'>
            <label htmlFor='employer'>choose vehicle</label>
            <select className='choose-em' id='employer'  onChange={(e) => handleChooseOutEmployer(e, 'update-vehicle')}>
              <SelectOptions 
                options={vehicles} 
                state='end'
              />
            </select>
          </div>
        </form>

        {vehicleToUpdate && 
        <form className='employer-data' onSubmit={(e) => handleUpdateEmployerAndvehicle(e, {type: 'vehicle'})}>
        <p className='form-title'>Change the <span style={{color: '#000'}}>( {vehicleToUpdate.name} )</span> Expenses data</p>
          
        <div className='form-layer price-value'>
          <p>Petrol</p>
          <input className='choose-em' type='number' value={vehicleToUpdate.expenses.petrol} onChange={handleUpdatevehicle} name='petrol' min='0' placeholder='$$$' />
        </div>
        <div className='form-layer price-value'>
          <p>Oil</p>
          <input className='choose-em' type='number' value={vehicleToUpdate.expenses.oil} onChange={handleUpdatevehicle} name='oil' min='0' placeholder='$$$' />
        </div>
        <div className='form-layer price-value'>
          <p>Repairs</p>
          <input className='choose-em' type='number' value={vehicleToUpdate.expenses.repairs} onChange={handleUpdatevehicle} name='repairs' min='0' placeholder='$$$' />
        </div>
        {saveUpdatevehicle && <button>Save</button>}
        </form>
        }
      </>}
    </div>
  )
}

export default FinishToEmployer;